export function _throw(e) {
    throw e;
}
export { _throw as _ };
